import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '~/src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <Note variant="warning" mdxType="Note">
 Stack interface guidelines coming soon!
    </Note>
    <h2>{`Anatomy`}</h2>
    <img width="960" alt="Example of the Stack component in use showing a text input next to a group of buttons. The stack is shown both horizontally and vertically." src="https://github.com/primer/primitives/assets/18661030/5b8649e0-1c3e-4845-abb1-c339b628d056" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      